import { createRootRoute, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { CookieConsentBanner } from "@/components/application/cookie-consent/cookie-consent-banner";
import { PostHogPageviewTracker } from "@/components/monitoring/PostHogPageviewTracker";
import { Toaster } from "@/components/application/notifications/toaster";
import { AriaRouteProvider } from "@/providers/route-provider";

export const Route = createRootRoute({
  component: () => {
    return (
      <AriaRouteProvider>
        <div className="text-foreground min-h-screen">
          <CookieConsentBanner />
          <main>
            <Outlet />
          </main>
        </div>
        <PostHogPageviewTracker />
        <Toaster />
        <TanStackRouterDevtools />
      </AriaRouteProvider>
    );
  },
});
